import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useAppSelector } from 'src/services/redux/app/store';

const REACT_APP_API_URL = `${process.env.REACT_APP_API_URL}`;

export const useCustomerVisitsList = (params: any = {}, onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const { page, limit, sortBy, search, sales_staff, start_date, end_date, customer_id, customer_type, erp_customer_id } = params;

  const requestParams = {
    contact_info_id: user?.company_id,
    page,
    limit,
    sortBy,
    search,
    sales_staff,
    start_date,
    end_date,
    // Müşteri kartı bazlı listeleme: isim araması yerine kimlik ile filtrele
    customer_id,
    customer_type,
    erp_customer_id,
  };
  const requestUrl = REACT_APP_API_URL + '/customer-visits/list';
  const fetchData = async () => {
    const res = await axios.get<any>(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['customer-visits-list', params], fetchData, {
    refetchOnWindowFocus: false,
    onError,
    staleTime: Infinity,
    retry: false,
  });
};

export const useCustomerVisitCreate = (onSuccess?: any, onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/customer-visits/create';
  return useMutation(
    (formPayload: any) => {
      return axios.post(`${requestUrl}`, { ...formPayload, contact_info_id: user?.company_id });
    },
    { onError, onSuccess },
  );
};

export const useCustomerVisitUpdate = (onSuccess?: any, onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/customer-visits/update';
  return useMutation(
    (formPayload: any) => {
      return axios.post(`${requestUrl}`, { ...formPayload, contact_info_id: user?.company_id });
    },
    { onError, onSuccess },
  );
};

export const useCustomerVisitDelete = (onSuccess?: any, onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/customer-visits/delete';
  return useMutation(
    (formPayload: any) => {
      return axios.post(`${requestUrl}`, { ...formPayload, contact_info_id: user?.company_id });
    },
    { onError, onSuccess },
  );
};

export const useSalesStaffList = (onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestParams = { id: user?.company_id, limit: 1000 };
  const requestUrl = REACT_APP_API_URL + '/company/users/saleslist';
  const fetchData = async () => {
    const res = await axios.get<any>(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['sales-staff-list'], fetchData, {
    refetchOnWindowFocus: false,
    onError,
    staleTime: Infinity,
    retry: false,
    enabled: !!user?.company_id,
  });
};

// useCustomersListForSelect kaldırıldı - artık useAllCustomersForSelect (customers/service) kullanılıyor
